import React, { Component } from "react";
import firebase from "firebase";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import * as fo from "../../common/FormatFunctions";
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";

export class Employees extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      clientList: [],
      userSelected: false,
      selectedUser: "",
      selectedUserId: "",
      selectedUserLastUpdatedDateTime: "",
      selectedUserFirstName: "",
      selectedUserSurname: "",
      selectedUserAddressLine1: "",
      selectedUserAddressLine2: "",
      selectedUserPostcode: "",
      selectedUserTelephone: "",
      selectedUserEmail: "",
      selectedUserLabel: "",
      selectedUserLevel: [],
      selectedUserNotes: "",
      selectedUserRoleType: "",
      userEdited: false,
      editedUserId: "",
      editedUserLastUpdatedDateTime: "",
      editedUserFirstName: "",
      editedUserSurname: "",
      editedUserAddressLine1: "",
      editedUserAddressLine2: "",
      editedUserPostcode: "",
      editedUserTelephone: "",
      editedUserEmail: "",
      editedUserLabel: "",
      editedUserLevel: [],
      editedUserNotes: "",
      editedUserRoleType: "",
      userAdded: false,
      emailExists: false,
      deleteDialog: false,
      expandedRows: false,
      // Holiday Start
      holidaysSelected: false,
      holidayAdded: false,
      setStartDate: "",
      setEndDate: "",
      datesReturned: [],
      displayCreateButton: false,
      holidayList: [],
      holidayExpandedRows: false,
      holidayCreateView: false,
      //Monday
      classOnMonday: false,
      mondayStart: "",
      mondayEnd: "",
      mondayClosed: false,
      //Tuesday
      classOnTuesday: false,
      tuesdayStart: "",
      tuesdayEnd: "",
      tuesdayClosed: false,
      //Wednesday
      classOnWednesday: false,
      wednesdayStart: "",
      wednesdayEnd: "",
      wednesdayClosed: false,
      //Thursday
      classOnThursday: false,
      thursdayStart: "",
      thursdayEnd: "",
      thursdayClosed: false,
      //Friday
      classOnFriday: false,
      fridayStart: "",
      fridayEnd: "",
      fridayClosed: false,
      //Saturday
      classOnSaturday: false,
      saturdayStart: "",
      saturdayEnd: "",
      saturdayClosed: false,
      //Sunday
      classOnSunday: false,
      sundayStart: "",
      sundayEnd: "",
      sundayClosed: false
    };

    this.displayDates = this.displayDates.bind(this);
  }

  componentDidMount = () => {
    if (localStorage.getItem("roleType") === "10") {
      this.getClients();
    } else {
      this.getClient();
    }
  };

  getClient = async () => {
    this.setState({ loaded: false });

    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");
    userRequest.id = localStorage.getItem("userId");

    await api("userApiV1UserGetAccount", userRequest).then(res => {
      if (res.data) {
        if (res.data.lastUpdatedDateTime) {
          res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let userResponse = Belfastpilatesappspotcom.UserResponse.constructFromObject(
          res.data
        );
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          let users = [];
          users.push(userResponse);
          this.setState({
            clientList: users
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "User could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("userApiV1UserGetAccount has failed");
      }
    });

    this.setState({ loaded: true });
  };

  getClients = async () => {
    this.setState({ loaded: false });

    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");

    await api("userApiV1UserListInBusiness", userRequest).then(res => {
      if (res.data) {
        if (Array.isArray(res.data.users)) {
          res.data.users.forEach(e => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
          });
        }

        let userResponse = Belfastpilatesappspotcom.UserResponse.constructFromObject(
          res.data
        );
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            clientList: userResponse.users
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Users could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("userApiV1UserListInBusiness has failed");
      }
    });

    this.setState({ loaded: true });
  };

  updateClient = async () => {
    if (
      !this.state.editedUserFirstName ||
      !this.state.editedUserSurname ||
      !this.state.editedUserTelephone ||
      !this.state.editedUserEmail ||
      !Array.isArray(this.state.editedUserLevel)
    ) {
      this.growl.show({
        severity: "error",
        summary: "Missing Fields",
        detail: "Please fill in all required fields",
        life: 3000
      });
    } else {
      let userRequest = new Belfastpilatesappspotcom.UserRequest();
      userRequest.codeTag = localStorage.getItem("globalBid");
      userRequest.id = this.state.editedUserId;
      userRequest.lastUpdatedDateTime = this.state.editedUserLastUpdatedDateTime;
      userRequest.firstName = this.state.editedUserFirstName;
      userRequest.surname = this.state.editedUserSurname;
      userRequest.addressLine1 = this.state.editedUserAddressLine1;
      userRequest.addressLine2 = this.state.editedUserAddressLine2;
      userRequest.postcode = this.state.editedUserPostcode;
      userRequest.contactTelephone = this.state.editedUserTelephone;
      userRequest.label = this.state.editedUserLabel;
      userRequest.level = this.state.editedUserLevel;
      userRequest.notes = this.state.editedUserNotes;
      userRequest.roleType = this.state.editedUserRoleType;

      await api("userApiV1UserUpdateAccount", userRequest).then(res => {
        if (res.data) {
          let userResponse = Belfastpilatesappspotcom.UserResponse.constructFromObject(
            res.data
          );
          console.log(userResponse);

          if (userResponse.errorCode === 0) {
            this.setState({ userEdited: false }, () => {
              if (localStorage.getItem("roleType") === "10") {
                this.getClients();
              } else {
                this.getClient();
              }
            });
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "User could not be updated, please try again",
              life: 3000
            });
          }
        } else {
          console.log("userApiV1UserUpdateAccount has failed");
        }
      });
    }
  };

  createClient = async () => {
    if (
      !this.state.editedUserFirstName ||
      !this.state.editedUserSurname ||
      !this.state.editedUserTelephone ||
      !this.state.editedUserEmail ||
      !Array.isArray(this.state.editedUserLevel)
    ) {
      this.growl.show({
        severity: "error",
        summary: "Missing Fields",
        detail: "Please fill in all required fields",
        life: 3000
      });
    } else {
      let userRequest = new Belfastpilatesappspotcom.UserRequest();
      userRequest.codeTag = localStorage.getItem("globalBid");
      userRequest.firstName = this.state.editedUserFirstName;
      userRequest.surname = this.state.editedUserSurname;
      userRequest.addressLine1 = this.state.editedUserAddressLine1;
      userRequest.addressLine2 = this.state.editedUserAddressLine2;
      userRequest.postcode = this.state.editedUserPostcode;
      userRequest.contactTelephone = this.state.editedUserTelephone;
      userRequest.email = this.state.editedUserEmail;
      userRequest.label = this.state.editedUserLabel;
      userRequest.level = this.state.editedUserLevel;
      userRequest.notes = this.state.editedUserNotes;
      userRequest.roleType = this.state.editedUserRoleType;

      await api("userApiV1UserCreate", userRequest).then(res => {
        if (res.data) {
          let userResponse = Belfastpilatesappspotcom.UserResponse.constructFromObject(
            res.data
          );
          console.log(userResponse);

          if (userResponse.errorCode === 0) {
            this.setState(
              {
                userEdited: false,
                userAdded: false,
                editedUserRoleType: ""
              },
              () => {
                firebase
                  .auth()
                  .createUserWithEmailAndPassword(
                    this.state.editedUserEmail,
                    "password"
                  )
                  .then(async () => {
                    await firebase
                      .auth()
                      .sendPasswordResetEmail(this.state.editedUserEmail)
                      .then(() => {
                        this.growl.show({
                          severity: "success",
                          summary: "Success",
                          detail:
                            "User successfully created, create password email sent to user",
                          life: 6000
                        });
                        this.getClients();
                      });
                  });
              }
            );
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "User could not be created, please try again",
              life: 3000
            });
          }
        } else {
          console.log("userApiV1UserCreate has failed");
        }
      });
    }
  };

  deleteClient = async () => {
    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");
    userRequest.id = this.state.selectedUserId;
    userRequest.lastUpdatedDateTime = this.state.selectedUserLastUpdatedDateTime;

    await api("userApiV1UserDelete", userRequest).then(res => {
      if (res.data) {
        let userResponse = Belfastpilatesappspotcom.UserResponse.constructFromObject(
          res.data
        );
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({ userEdited: false, userAdded: false }, () => {
            this.getClients();
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "User could not be deleted, please try again",
            life: 3000
          });
        }
      } else {
        console.log("userApiV1UserDelete has failed");
      }
    });
  };

  createHoliday = async () => {
    let calendarRequest = new Belfastpilatesappspotcom.CalendarRequest();
    calendarRequest.codeTag = localStorage.getItem("globalBid");
    calendarRequest.userId = this.state.editedUserId;
    calendarRequest.countryCode = localStorage.getItem("countryCode");
    calendarRequest.type = "EM";

    let datesJson = {};
    let daysOpeningHours = {};

    if (Array.isArray(this.state.datesReturned)) {
      this.state.datesReturned.forEach(bean => {
        let times = [];

        if (bean.startTime) {
          times[0] = fo.formatDate(bean.startTime, "hhmm");
        } else {
          times[0] = "1110";
        }

        if (bean.endTime) {
          times[1] = fo.formatDate(bean.endTime, "hhmm");
        } else {
          times[1] = "1111";
        }

        daysOpeningHours[bean.displayDate] = times;
      });

      datesJson.daysOpeningHours = daysOpeningHours;
    }

    calendarRequest.availableHours = JSON.stringify(datesJson);

    await api("calendarApiV1CalendarGenerateSetDates", calendarRequest).then(
      res => {
        if (res.data) {
          let calendarResponse = Belfastpilatesappspotcom.CalendarResponse.constructFromObject(
            res.data
          );
          console.log(calendarResponse);

          if (calendarResponse.errorCode === 0) {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "User holiday successfully created",
              life: 3000
            });

            this.setState(
              {
                datesReturned: [],
                holidaysSelected: true,
                holidayList: [],
                setEndDate: "",
                setStartDate: "",
                displayCreateButton: false
              },
              () => {
                this.getCalendarByUserId(this.state.editedUserId);
              }
            );
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "User holiday could not be created, please try again",
              life: 3000
            });
          }
        } else {
          console.log("calendarApiV1CalendarGenerateSetDates has failed");
        }
      }
    );
  };

  getDatesSelected = async () => {
    let scheduleRequest = new Belfastpilatesappspotcom.ScheduleRequest();
    scheduleRequest.codeTag = localStorage.getItem("globalBid");
    scheduleRequest.userId = this.state.selectedUserId;
    scheduleRequest.generateStartDate = this.state.setStartDate;
    scheduleRequest.generateEndDate = this.state.setEndDate;
    scheduleRequest.instructorIds = [this.state.selectedUserId];
    scheduleRequest.recurrenceType = "DAILY";

    await api("scheduleApiV1ScheduleGetListOfDates", scheduleRequest).then(
      res => {
        if (res.data) {
          let scheduleResponse = Belfastpilatesappspotcom.ScheduleResponse.constructFromObject(
            res.data
          );
          console.log(scheduleResponse);

          if (scheduleResponse.errorCode === 0) {
            this.setState({
              datesReturned: scheduleResponse.scheduleList,
              displayCreateButton: true
            });
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "Dates could not be retrieved for selected range",
              life: 3000
            });
          }
        } else {
          console.log("scheduleApiV1ScheduleGetListOfDates has failed");
        }
      }
    );
  };

  getCalendarByUserId = async userId => {
    let calendarRequest = new Belfastpilatesappspotcom.CalendarRequest();
    calendarRequest.codeTag = localStorage.getItem("globalBid");
    calendarRequest.userId = userId;
    calendarRequest.type = "EM"; //EM = Employee Annual Leave

    await api("calendarApiV1CalendarListForUser", calendarRequest).then(res => {
      if (res.data) {
        if (Array.isArray(res.data.calendarList)) {
          res.data.calendarList.forEach(e => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
            if (e.dateCreated) {
              e.dateCreated = e.dateCreated.toJSON();
            }
          });
        }

        let calendarResponse = Belfastpilatesappspotcom.CalendarResponse.constructFromObject(
          res.data
        );
        console.log(calendarResponse);

        if (calendarResponse.errorCode === 0) {
          this.setState({
            holidayList: calendarResponse.calendarList,
            holidaysSelected: true,
            editedUserId: userId,
            userAdded: false,
            userSelected: false,
            userEdited: false
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Holidays could not be retrieved, please try again",
            life: 3000
          });
        }
      } else {
        console.log("calendarApiV1CalendarListForUser has failed");
      }
    });
  };

  calendarDelete = async data => {
    let calendarRequest = new Belfastpilatesappspotcom.CalendarRequest();
    calendarRequest.codeTag = localStorage.getItem("globalBid");
    calendarRequest.userId = data.userId;
    calendarRequest.id = data.id;
    calendarRequest.lastUpdatedDateTime = data.lastUpdatedDateTime;

    await api("calendarApiV1CalendarDelete", calendarRequest).then(res => {
      if (res.data) {
        let calendarResponse = Belfastpilatesappspotcom.CalendarResponse.constructFromObject(
          res.data
        );
        console.log(calendarResponse);

        if (calendarResponse.errorCode === 0) {
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Holiday successfully deleted",
            life: 3000
          });

          let holidays = [];
          let i = 0;

          if (Array.isArray(this.state.holidayList)) {
            holidays = this.state.holidayList;
            holidays.forEach(e => {
              if (calendarResponse.id === e.id || data.id === e.id) {
                holidays.splice(i, 1);
              }
              i++;
            });
          }

          this.setState({
            holidayList: holidays,
            holidaysSelected: true,
            editedUserId: data.userId,
            userAdded: false,
            userSelected: false,
            userEdited: false
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Holiday could not be deleted, please try again",
            life: 3000
          });
        }
      } else {
        console.log("calendarApiV1CalendarDelete has failed");
      }
    });
  };

  updateDatesTime = (e, field, value) => {
    var bean = this.state.datesReturned;

    if (Array.isArray(bean)) {
      bean.forEach(date => {
        if (date.displayDate === e.displayDate) {
          if (field === "dayChecked") {
            if (value) {
              date[field] = value;
            } else {
              date[field] = value;
              this.updateDatesTime(e, "startTime", "");
              this.updateDatesTime(e, "endTime", "");
            }
          } else {
            date[field] = value;
          }
        }
      });
    }

    this.setState({
      datesReturned: bean
    });
  };

  getTimeInputs = e => {
    if (e.dayChecked) {
      return (
        <div>
          <div className="ui-g-6">
            <pr.Calendar
              value={e.startTime || ""}
              onChange={g => {
                this.updateDatesTime(e, "startTime", g.value);
              }}
              timeOnly={true}
              hourFormat="24"
              inputStyle={{
                width: "100%"
              }}
              placeholder="Start"
            />
          </div>
          <div className="ui-g-6">
            <pr.Calendar
              value={e.endTime || ""}
              onChange={g => {
                this.updateDatesTime(e, "endTime", g.value);
              }}
              timeOnly={true}
              hourFormat="24"
              inputStyle={{
                width: "100%"
              }}
              placeholder="End"
            />
          </div>
        </div>
      );
    } else {
      return <label />;
    }
  };

  displaySingleDate = e => {
    return (
      <div className="ui-g-12">
        <div className="ui-g-6">
          <b>{e.displayDay + " - " + e.displayDate}</b>
        </div>
        <div className="ui-g-6">
          <label>Custom time? </label>
          <pr.Checkbox
            onChange={g => this.updateDatesTime(e, "dayChecked", g.checked)}
            checked={
              this.state.datesReturned[
                this.state.datesReturned.findIndex(
                  p => p.displayDate === e.displayDate
                )
              ].dayChecked
            }
            style={{ align: "middle" }}
          />
        </div>
        <div className="ui-g-6">{this.getTimeInputs(e)}</div>
      </div>
    );
  };

  displayDates = () => {
    let datesToDisplay = [];
    let i = 0;

    if (Array.isArray(this.state.datesReturned)) {
      this.state.datesReturned.forEach(e => {
        if (e.displayDay && e.displayDate) {
          datesToDisplay[i] = this.displaySingleDate(e);
          i++;
        }
      });
    }
    return datesToDisplay;
  };

  getSelectionView = data => {
    return (
      <div className="ui-g-12">
        <div className="ui-g-12" style={{ padding: "0" }}>
          <div className="ui-g-12 ui-md-6">
            <b>First Name: </b>
            <label>{data.firstName || ""}</label>
          </div>
          <div className="ui-g-12 ui-md-6">
            <b>Surname: </b>
            <label>{data.surname || ""}</label>
          </div>
        </div>

        <div className="ui-g-12" style={{ padding: "0" }}>
          <div className="ui-g-12 ui-md-6">
            <b>Email: </b>
            <label>{data.email || ""}</label>
          </div>
          <div className="ui-g-12 ui-md-6">
            <b>Telephone: </b>
            <label>{data.contactTelephone || ""}</label>
          </div>
        </div>

        <div className="ui-g-12" style={{ padding: "0" }}>
          <div className="ui-g-12 ui-md-6">
            <b>Address Line 1: </b>
            <label>{data.addressLine1 || ""}</label>
          </div>
          <div className="ui-g-12 ui-md-6">
            <b>Address Line 2: </b>
            <label>{data.addressLine2 || ""}</label>
          </div>
        </div>

        <div className="ui-g-12" style={{ padding: "0" }}>
          <div className="ui-g-12 ui-md-6">
            <b>Postcode: </b>
            <label>{data.postcode || ""}</label>
          </div>
          <div className="ui-g-12 ui-md-6">
            <b>Level: </b>
            <label>{data.level || ""}</label>
          </div>
        </div>

        <div className="ui-g-12" style={{ padding: "0" }}>
          <div className="ui-g-12 ui-md-6">
            <b>Label: </b>
            <label>{data.label || ""}</label>
          </div>
        </div>

        <div className="ui-g-12" style={{ padding: "0" }}>
          <div className="ui-g-12">
            <b>Notes:</b>
            <textarea
              rows="10"
              readOnly={true}
              value={data.notes || ""}
              style={{ width: "100%", resize: "none" }}
            />
          </div>
        </div>

        <div className="ui-g-12" style={{ padding: "0" }}>
          <div className="ui-g-12">
            <pr.Button
              className="secondary-btn"
              label="Edit"
              icon="pi pi-pencil"
              onClick={() => {
                this.setState({
                  userAdded: false,
                  userSelected: false,
                  userEdited: true,
                  selectedUserId: data.id,
                  editedUserFirstName: data.firstName,
                  editedUserSurname: data.surname,
                  editedUserAddressLine1: data.addressLine1,
                  editedUserAddressLine2: data.addressLine2,
                  editedUserPostcode: data.postcode,
                  editedUserTelephone: data.contactTelephone,
                  editedUserEmail: data.email,
                  editedUserLabel: data.label,
                  editedUserLevel: data.level,
                  editedUserNotes: data.notes,
                  editedUserRoleType: data.roleType,
                  editedUserLastUpdatedDateTime: data.lastUpdatedDateTime,
                  editedUserId: data.id
                });
              }}
              style={{ float: "right" }}
            />
            {localStorage.getItem("userId") !== this.state.selectedUserId &&
            localStorage.getItem("roleType") === "10" ? (
              <pr.Button
                className="secondary-btn"
                label="Delete"
                icon="pi pi-trash"
                onClick={() => {
                  this.setState({ deleteDialog: true });
                }}
                style={{ float: "right" }}
              />
            ) : (
              <label />
            )}
            <pr.Button
              className="secondary-btn"
              label="User Holidays"
              icon="pi pi-calendar"
              onClick={() => {
                this.getCalendarByUserId(data.id);
              }}
              style={{ float: "right" }}
            />
          </div>
        </div>
      </div>
    );
  };

  getHolidaySelectionView = data => {
    return (
      <div className="ui-g-12">
        <div className="ui-g-12">
          <div className="ui-g-12 ui-md-6">
            <b>Date: </b>
            <label>{data.day + "/" + data.month + "/" + data.year || ""}</label>
          </div>
          <div className="ui-g-12 ui-md-6">
            <b>Day of the week: </b>
            <label>{data.dayOfWeek || ""}</label>
          </div>
          <div className="ui-g-12 ui-md-6">
            <b>Start Time: </b>
            {data.startTime === "11:10" || data.startTime === "1110" ? (
              <label>All Day</label>
            ) : (
              <label>{data.startTime}</label>
            )}
          </div>
          <div className="ui-g-12 ui-md-6">
            <b>End Time: </b>
            {data.endTime === "11:11" || data.endTime === "1111" ? (
              <label>All Day</label>
            ) : (
              <label>{data.endTime}</label>
            )}
          </div>
        </div>
        {localStorage.getItem("roleType") === "10" ? (
          <div className="ui-g-12">
            <pr.Button
              className="secondary-btn"
              label="Delete"
              icon="pi pi-trash"
              onClick={() => {
                this.setState({
                  deleteCalendarDialog: true,
                  calendarData: data
                });
              }}
              style={{ float: "right" }}
            />
          </div>
        ) : (
          <label />
        )}
      </div>
    );
  };

  render() {
    const levelOptions = [
      { label: "Consultation", value: "Consultation" },
      { label: "Beginner/Progressive", value: "Beginner/Progressive" },
      { label: "Progressive/Intermediate", value: "Progressive/Intermediate" },
      { label: "Intermediate/Advanced", value: "Intermediate/Advanced" },
      { label: "Reformer", value: "Reformer" },
      { label: "Mum and Baby", value: "Mum and Baby" },
      { label: "Antenatal", value: "Antenatal" },
      { label: "Kids", value: "Kids" },
      { label: "Mature Movers", value: "Mature Movers" }
    ];

    const roleTypeOptions = [
      { label: "Admin", value: 10 },
      { label: "Employee", value: 20 }
    ];

    if (!this.state.loaded) {
      return (
        <center>
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={el => (this.growl = el)}
          />
          <LoadScreen />
        </center>
      );
    }
    return (
      <div className="ui-g">
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        <pr.Dialog
          header="Delete Employee"
          footer={
            <div>
              <pr.Button
                className="secondary-btn"
                label="Yes"
                onClick={() => {
                  this.setState({ deleteDialog: false, userEdited: false });
                  this.deleteClient();
                }}
                style={{ float: "right" }}
              />
              <pr.Button
                className="secondary-btn"
                label="No"
                onClick={() => {
                  this.setState({ deleteDialog: false });
                }}
                style={{ float: "right" }}
              />
            </div>
          }
          visible={this.state.deleteDialog}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.setState({ deleteDialog: false })}
        >
          Are you sure you want to delete?
        </pr.Dialog>
        <pr.Dialog
          header="Delete Holiday"
          footer={
            <div>
              <pr.Button
                className="secondary-btn"
                label="Yes"
                onClick={() => {
                  this.setState({ deleteCalendarDialog: false });
                  this.calendarDelete(this.state.calendarData);
                }}
                style={{ float: "right" }}
              />
              <pr.Button
                className="secondary-btn"
                label="No"
                onClick={() => {
                  this.setState({ deleteCalendarDialog: false });
                }}
                style={{ float: "right" }}
              />
            </div>
          }
          visible={this.state.deleteCalendarDialog}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.setState({ deleteCalendarDialog: false })}
        >
          Are you sure you want to delete?
        </pr.Dialog>

        <div className="ui-g-12">
          <div className="card">
            <div className="ui-g">
              {this.state.userEdited ||
              this.state.holidaysSelected ||
              this.state.holidayCreateView ? (
                <label />
              ) : (
                <div className="ui-g-12">
                  <pr.DataTable
                    value={this.state.clientList}
                    expandedRows={this.state.expandedRows}
                    onRowToggle={e => {
                      this.setState(
                        {
                          expandedRows: e.data
                        },
                        () => {
                          if (e.data[0]) {
                            this.setState({
                              selectedUserId: e.data[0].id,
                              selectedUserLastUpdatedDateTime:
                                e.data[0].lastUpdatedDateTime
                            });
                          }
                        }
                      );
                    }}
                    rowExpansionTemplate={this.getSelectionView}
                    header="Select an Employee"
                    autoLayout={true}
                    paginator={false}
                    alwaysShowPaginator={false}
                    scrollable={true}
                  >
                    <pr.Column expander={true} style={{ width: "3em" }} />
                    <pr.Column
                      field="firstName"
                      header="First Name"
                      sortable={true}
                      filter={true}
                      style={{ overflow: "auto" }}
                    />
                    <pr.Column
                      field="surname"
                      header="Surname"
                      sortable={true}
                      filter={true}
                      style={{ overflow: "auto" }}
                    />
                    <pr.Column
                      field="level"
                      header="Level"
                      body={e => {
                        let levelArray = [];

                        if (Array.isArray(e.level)) {
                          e.level.forEach(f => {
                            levelArray.push(f + "\n");
                          });
                        }

                        return levelArray;
                      }}
                      sortable={true}
                      filter={true}
                      style={{ overflow: "auto" }}
                    />
                  </pr.DataTable>
                  {localStorage.getItem("roleType") === "10" ? (
                    <pr.Button
                      label="Add New"
                      onClick={() => {
                        this.setState({
                          userSelected: false,
                          userEdited: true,
                          userAdded: true,
                          editedUserFirstName: "",
                          editedUserSurname: "",
                          editedUserAddressLine1: "",
                          editedUserAddressLine2: "",
                          editedUserPostcode: "",
                          editedUserTelephone: "",
                          editedUserEmail: "",
                          editedUserLabel: "",
                          editedUserLevel: [],
                          editedUserNotes: "",
                          editedUserRoleType: ""
                        });
                      }}
                      style={{ width: "100%" }}
                    />
                  ) : (
                    <label />
                  )}
                </div>
              )}

              {!this.state.holidaysSelected ? (
                <label />
              ) : (
                <div className="ui-g-12">
                  <div className="ui-g-12">
                    <pr.Button
                      label="Close"
                      icon="pi pi-times"
                      onClick={() => {
                        this.setState({
                          userAdded: false,
                          userEdited: false,
                          userSelected: false,
                          holidaysSelected: false,
                          holidayCreateView: false
                        });
                      }}
                      style={{ float: "right" }}
                    />
                    {localStorage.getItem("roleType") === "10" ? (
                      <pr.Button
                        label="Create Holiday"
                        icon="pi pi-calendar"
                        onClick={() => {
                          this.setState({
                            userAdded: false,
                            userEdited: false,
                            userSelected: false,
                            holidaysSelected: false,
                            holidayCreateView: true
                          });
                        }}
                        style={{ float: "right" }}
                      />
                    ) : (
                      <label />
                    )}
                  </div>
                  <div className="ui-g-12">
                    <pr.DataTable
                      value={this.state.holidayList}
                      expandedRows={this.state.holidayExpandedRows}
                      onRowToggle={e =>
                        this.setState({
                          holidayExpandedRows: e.data
                        })
                      }
                      rowExpansionTemplate={this.getHolidaySelectionView}
                      header="Users Holidays"
                      autoLayout={true}
                      paginator={false}
                      alwaysShowPaginator={false}
                      scrollable={true}
                    >
                      <pr.Column expander={true} style={{ width: "3em" }} />
                      <pr.Column
                        field=""
                        body={e => {
                          let date = "";
                          date = e.day + "/" + e.month + "/" + e.year;
                          return date;
                        }}
                        header="Date"
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="dayOfWeek"
                        header="Day Of Week"
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="startTime"
                        header="From"
                        body={e => {
                          let time = "";
                          if (
                            e.startTime === "1110" ||
                            e.startTime === "11:10"
                          ) {
                            time = "All Day";
                          } else {
                            time = e.startTime;
                          }
                          return time;
                        }}
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="endTime"
                        header="To"
                        body={e => {
                          let time = "";
                          if (e.endTime === "1111" || e.endTime === "11:11") {
                            time = "All Day";
                          } else {
                            time = e.endTime;
                          }
                          return time;
                        }}
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                    </pr.DataTable>
                  </div>
                </div>
              )}

              {!this.state.holidayCreateView ? (
                <label />
              ) : (
                <div className="ui-g-12">
                  <div className="ui-g-12">
                    <label>Select the date range you wish to book off</label>
                  </div>

                  <div className="ui-g-12">
                    <div className="ui-g-12 ui-md-6">
                      <pr.Calendar
                        dateFormat="dd/mm/yy"
                        placeholder="From Date"
                        value={this.state.setStartDate}
                        onChange={e => this.setState({ setStartDate: e.value })}
                        showTime={true}
                        showSeconds={true}
                      />
                    </div>
                    <div className="ui-g-12 ui-md-6">
                      <pr.Calendar
                        dateFormat="dd/mm/yy"
                        placeholder="To Date"
                        value={this.state.setEndDate}
                        onChange={e => this.setState({ setEndDate: e.value })}
                        showTime={true}
                        showSeconds={true}
                      />
                    </div>
                  </div>

                  <div className="ui-g-12">
                    {this.state.setStartDate && this.state.setEndDate ? (
                      <pr.Button
                        label="Get Dates selected"
                        onClick={() => {
                          this.getDatesSelected();
                        }}
                        style={{ float: "right" }}
                      />
                    ) : (
                      <label />
                    )}
                    <pr.Button
                      label="Cancel"
                      onClick={() => {
                        this.setState({
                          userAdded: false,
                          userEdited: false,
                          userSelected: true,
                          holidaysSelected: true,
                          datesReturned: [],
                          setStartDate: "",
                          setEndDate: "",
                          holidayCreateView: false
                        });
                      }}
                      style={{ float: "right" }}
                    />
                  </div>

                  <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                    {this.displayDates()}
                  </div>

                  {/* Display button to run create holiday sequence */}
                  {this.state.displayCreateButton ? (
                    <div className="ui-g-12">
                      <pr.Button
                        label="Create Holiday"
                        onClick={() => {
                          this.createHoliday();
                        }}
                        style={{ float: "right" }}
                      />
                    </div>
                  ) : (
                    <label />
                  )}
                </div>
              )}

              {!this.state.userEdited ? (
                <label />
              ) : (
                <div className="ui-g-12">
                  <div className="ui-g-12">
                    <pr.Button
                      className="secondary-btn"
                      icon="pi pi-times"
                      onClick={() => {
                        this.setState({
                          userAdded: false,
                          userEdited: false,
                          userSelected: true
                        });
                      }}
                      style={{ float: "right" }}
                    />
                  </div>

                  <div className="ui-g-12">
                    <div className="ui-g-12">
                      <div
                        className="ui-g-12 ui-md-6"
                        style={{ padding: "1em" }}
                      >
                        <span className="md-inputfield form-field">
                          <pr.InputText
                            value={this.state.editedUserFirstName}
                            onChange={e => {
                              this.setState({
                                editedUserFirstName: e.target.value
                              });
                            }}
                            style={{ width: "100%" }}
                          />
                          <label>First Name*</label>
                        </span>
                      </div>
                      <div
                        className="ui-g-12 ui-md-6"
                        style={{ padding: "1em" }}
                      >
                        <span className="md-inputfield form-field">
                          <pr.InputText
                            value={this.state.editedUserSurname}
                            onChange={e => {
                              this.setState({
                                editedUserSurname: e.target.value
                              });
                            }}
                            style={{ width: "100%" }}
                          />
                          <label>Surname*</label>
                        </span>
                      </div>
                      {this.state.userAdded ? (
                        <div
                          className="ui-g-12 ui-md-6"
                          style={{ padding: "1em" }}
                        >
                          <span className="md-inputfield form-field">
                            <pr.InputText
                              value={this.state.editedUserEmail}
                              onChange={e => {
                                if (Array.isArray(this.state.clientList)) {
                                  this.state.clientList.some(f => {
                                    if (e.target.value === f.email) {
                                      this.setState({
                                        emailExists: true
                                      });
                                      return true;
                                    } else {
                                      this.setState({
                                        emailExists: false
                                      });
                                      return false;
                                    }
                                  });
                                }

                                this.setState({
                                  editedUserEmail: e.target.value
                                });
                              }}
                              style={{ width: "100%" }}
                            />
                            <label>Email*</label>
                          </span>
                          {this.state.emailExists ? (
                            <label style={{ color: "red" }}>
                              Email already exists
                            </label>
                          ) : (
                            <label />
                          )}
                        </div>
                      ) : (
                        <label />
                      )}
                      <div
                        className="ui-g-12 ui-md-6"
                        style={{ padding: "1em" }}
                      >
                        <span className="md-inputfield form-field">
                          <pr.InputText
                            value={this.state.editedUserTelephone}
                            onChange={e => {
                              this.setState({
                                editedUserTelephone: e.target.value
                              });
                            }}
                            style={{ width: "100%" }}
                          />
                          <label>Telephone</label>
                        </span>
                      </div>
                      <div
                        className="ui-g-12 ui-md-6"
                        style={{ padding: "1em" }}
                      >
                        <span className="md-inputfield form-field">
                          <pr.InputText
                            value={this.state.editedUserAddressLine1}
                            onChange={e => {
                              this.setState({
                                editedUserAddressLine1: e.target.value
                              });
                            }}
                            style={{ width: "100%" }}
                          />
                          <label>Address Line 1</label>
                        </span>
                      </div>
                      <div
                        className="ui-g-12 ui-md-6"
                        style={{ padding: "1em" }}
                      >
                        <span className="md-inputfield form-field">
                          <pr.InputText
                            value={this.state.editedUserAddressLine2}
                            onChange={e => {
                              this.setState({
                                editedUserAddressLine2: e.target.value
                              });
                            }}
                            style={{ width: "100%" }}
                          />
                          <label>Address Line 2</label>
                        </span>
                      </div>
                      <div
                        className="ui-g-12 ui-md-6"
                        style={{ padding: "1em" }}
                      >
                        <span className="md-inputfield form-field">
                          <pr.InputText
                            value={this.state.editedUserPostcode}
                            onChange={e => {
                              this.setState({
                                editedUserPostcode: e.target.value
                              });
                            }}
                            style={{ width: "100%" }}
                          />
                          <label>Postcode</label>
                        </span>
                      </div>
                      <div
                        className="ui-g-12 ui-md-6"
                        style={{ padding: "1em" }}
                      >
                        <span className="md-inputfield form-field">
                          <pr.InputText
                            value={this.state.editedUserLabel}
                            onChange={e => {
                              this.setState({
                                editedUserLabel: e.target.value
                              });
                            }}
                            style={{ width: "100%" }}
                          />
                          <label>Label</label>
                        </span>
                      </div>
                    </div>
                    <div className="ui-g-12">
                      <div
                        className="ui-g-12 ui-md-6"
                        style={{ padding: "1em", paddingTop: "19px" }}
                      >
                        <label>Level*</label>
                        <pr.MultiSelect
                          value={this.state.editedUserLevel || []}
                          options={levelOptions}
                          onChange={e => {
                            this.setState({ editedUserLevel: e.value });
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                      {localStorage.getItem("userId") ===
                        this.state.selectedUserId && !this.state.userAdded ? (
                        <label />
                      ) : (
                        <div
                          className="ui-g-12 ui-md-6"
                          style={{ padding: "1em" }}
                        >
                          <label style={{ fontSize: "0.9em" }}>
                            Role Type*
                          </label>
                          <pr.Dropdown
                            value={this.state.editedUserRoleType || ""}
                            options={roleTypeOptions}
                            onChange={e => {
                              this.setState({ editedUserRoleType: e.value });
                            }}
                            style={{ width: "100%" }}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="ui-g-12">
                    <label>Notes:</label>
                    <br />
                    <textarea
                      rows="10"
                      readOnly={false}
                      value={this.state.editedUserNotes}
                      onChange={e =>
                        this.setState({
                          editedUserNotes: e.target.value
                        })
                      }
                      style={{ width: "100%", resize: "none" }}
                    />
                  </div>

                  <div className="ui-g-12">
                    <pr.Button
                      label="Save"
                      disabled={this.state.emailExists}
                      onClick={() => {
                        this.state.userAdded
                          ? this.createClient()
                          : this.updateClient();
                      }}
                      style={{ float: "right" }}
                    />
                    <pr.Button
                      label="Cancel"
                      onClick={() => {
                        this.setState({
                          userAdded: false,
                          userEdited: false,
                          userSelected: true
                        });
                      }}
                      style={{ float: "right" }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Employees/Employees.js